import React from "react";
import GenerateInput from "../GenerateInput";
import { AI_AGENT } from "@/store/zustand/aiActionStore";

interface ChatPanelProps {
  agent?: AI_AGENT;
}

export const ChatPanel = React.memo(({ agent }: ChatPanelProps) => {
  return (
    <div className="w-full">
      <div className="mx-auto sm:max-w-2xl">
        {/* keep padding-top at 0 for usage indicator */}
        <div className="bg-background p-2 pb-1 pt-0">
          <div className="border-0 bg-background shadow-lg sm:rounded-t-xl pb-2">
            <GenerateInput isForChat={true} agent={agent} />
          </div>
        </div>
      </div>
    </div>
  );
});
